/**
 * Quiz Test Page (Company App Wrapper)
 *
 * @quebon/shared-learning의 QuizTestPage 공통 컴포넌트를 사용.
 * Company 앱의 quizScriptApi와 i18n을 주입.
 */
import { useTranslation } from 'react-i18next'
import { QuizTestPage as SharedQuizTestPage } from '@quebon/shared-learning'
import { quizScriptApi } from '@/api/quizScript'

export default function QuizTestPage() {
  const { t } = useTranslation('learner')

  return <SharedQuizTestPage api={quizScriptApi} t={t} />
}
